
// src/i18n/index.js

import i18next from 'i18next'
import moment from 'moment'
import message_ja from './message-ja'
import message_en from './message-en'

function initializeLang(lang) {
  switch(lang) {
    case 'ja':
      message_ja.initialize()
      break
    case 'en':
    default:
      message_en.initialize()
      break
  }
}

i18next.init({
  lng: 'ja',
  fallbackLng: 'en',
  resources: {
    ja: message_ja,
    en: message_en,
  },
  react: {
    wait: true
  },
  ns: ['default'],
  defaultNS: 'default',
  appendNamespaceToMissingKey: true,
  interpolation: {
    format: function(value, format, lng) {
      if (format === 'date') {                                                                                                                                                                                                                                                                                                                                                                                                                            
        const lastYear = moment().subtract(1, 'year').year()
        const reportedYear = moment(value).year()
        return moment(value).format( reportedYear > lastYear ? 'llll' : 'LLLL')
      }
      if (format === 'datetime')
        return moment(value).format('LLLL HH:mm:ss')
      if (format === 'fromNow') {
        const lastHalfYear = moment().subtract(6, 'month')
        const yesterday = moment().subtract(1, 'day')
        if (lastHalfYear.isAfter(value))
          return moment(value).format('LLLL')
        else if (yesterday.isAfter(value))
          return moment(value).format('llll')
        else
          return moment(value).format('l')
      }
      else
        return value
    }
  },
});

i18next.on('initialized', initializeLang)
i18next.on('languageChanged', initializeLang)

export default i18next;



// WEBPACK FOOTER //
// ./src/i18n/index.js